/**
 * URL values carried through the buying process.
 */
export const useSessionStore = defineStore('session', () => {
    const backLink = ref<string>();
    const affiliate = ref<string>();

    function clearBackLink() {
        backLink.value = undefined;
    }

    return {
        backLink,
        affiliate,
        clearBackLink,
    };
}, {
    persist: {
        ...storePersist.storePersistOptions,
        key: 'session-v6',
    },
});
